import {
  Component,
  Input,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { Tag } from "../../../models/tag.model";
import { EditTagsComponent } from "../edit-tags/edit-tags.component";
import { Router } from "@angular/router";
import { PatientService } from "../../../services/patient.service";
import * as moment from "moment";
import { EditNotesComponent } from "../edit-notes/edit-notes.component";

@Component({
  template: `
    <div class="tab-body row no-margin details">
      <div class="col-6">
        <p class="subheading" *ngIf="!data?.isDicom">{{ dataType }} Details</p>
        <p class="subheading" *ngIf="data?.isDicom">Dicom Image Details</p>

        <ul [ngSwitch]="dataType">
          <li class="row">
            <div class="col-3"><label>Patient ID</label></div>
            <div class="col-9" *ngIf="dataType == 'patient'">
              {{ data?.patientId }}
            </div>
            <div class="col-9 link" *ngIf="dataType != 'patient'">
              <span (click)="gotoPatient(data.patientId)">{{
                data?.patientId
              }}</span>
            </div>
          </li>
          <li class="row" *ngSwitchCase="'patient'">
            <div class="col-3"><label>Site</label></div>
            <div class="col-9">{{ tabDetails?.site }}</div>
          </li>
          <li class="row" *ngSwitchCase="'patient'">
            <div class="col-3"><label>Blood collected for genetics</label></div>
            <div class="col-9">{{ tabDetails?.blood }}</div>
          </li>
          <li class="row" *ngSwitchCase="'patient'">
            <div class="col-3"><label>Subject was enrolled in NHOS</label></div>
            <div class="col-9">{{ tabDetails?.nhocont }}</div>
          </li>
          <li class="row" *ngSwitchCase="'patient'">
            <div class="col-3"><label>Family ID</label></div>
            <div class="col-9">{{ data?.familyId }}</div>
          </li>
          <li class="row" *ngSwitchCase="'patient'">
            <div class="col-3"><label>Control Subject</label></div>
            <div class="col-9">{{ tabDetails?.controlSubject }}</div>
          </li>
          <li class="row" *ngSwitchCase="'patient'">
            <div class="col-3"><label>Relationship to Proband</label></div>
            <div class="col-9">{{ tabDetails?.probandRelationship }}</div>
          </li>
          <li class="row" *ngSwitchCase="'patient'">
            <div class="col-3"><label>Family Status</label></div>
            <div class="col-9">{{ data?.familyStatus }}</div>
          </li>
          <li class="row" *ngSwitchCase="'genetic'">
            <div class="col-3"><label>File Type</label></div>
            <div class="col-9">{{ tabDetails?.fileType }}</div>
          </li>
          <li class="row" *ngSwitchCase="'genetic'">
            <div class="col-3"><label>Study ID</label></div>
            <div class="col-9">{{ data?.studyId }}</div>
          </li>
          <li class="row" *ngSwitchCase="'genetic'">
            <div class="col-3"><label>Path</label></div>
            <div class="col-9">
              <a [href]="tabDetails?.path" target="_blank">{{
                tabDetails?.path
              }}</a>
            </div>
          </li>
          <li class="row" *ngSwitchCase="'genetic'">
            <div class="col-3"><label>Batch</label></div>
            <div class="col-9">{{ tabDetails?.batch }}</div>
          </li>
          <li class="row" *ngSwitchCase="'genetic'">
            <div class="col-3"><label>Alt ID</label></div>
            <div class="col-9">{{ tabDetails?.altId }}</div>
          </li>
          <li class="row" *ngSwitchCase="'genetic'">
            <div class="col-3"><label>Spec ID</label></div>
            <div class="col-9">{{ tabDetails?.specId }}</div>
          </li>
          <li class="row" *ngSwitchCase="'metabolomic'">
            <div class="col-3"><label>File Type</label></div>
            <div class="col-9">{{ data?.meta?.FILETYPE }}</div>
          </li>
          <ng-container *ngIf="dataType == 'image' && !data?.isDicom">
            <li class="row">
              <div class="col-3"><label>Site</label></div>
              <div class="col-9">{{ tabDetails?.site }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Visit ID</label></div>
              <div class="col-9">{{ data?.visitId }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Data photo taken</label></div>
              <div class="col-9">
                {{ moment(tabDetails?.photoDate).format("MMM DD, YYYY") }}
              </div>
            </li>
            <li class="row">
              <div class="col-3"><label>Study ID</label></div>
              <div class="col-9">{{ tabDetails?.studyId }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Eye</label></div>
              <div class="col-9">{{ tabDetails?.eye }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Image type</label></div>
              <div class="col-9">{{ tabDetails?.imageType }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Image platform</label></div>
              <div class="col-9">{{ tabDetails?.imagePlatform }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Comments</label></div>
              <div class="col-9">{{ tabDetails?.comments }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Upload Comments</label></div>
              <div class="col-9">{{ tabDetails?.uploadComments }}</div>
            </li>
          </ng-container>
          <ng-container *ngIf="dataType == 'image' && data?.isDicom">
            <li class="row">
              <div class="col-3"><label>S3 Path</label></div>
              <div class="col-9">{{ tabDetails?.s3originpath }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Eye</label></div>
              <div class="col-9">{{ tabDetails?.eye }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Study Date</label></div>
              <div class="col-9">{{ tabDetails?.studydate }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Study Type</label></div>
              <div class="col-9">{{ tabDetails?.studytype }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Series Type</label></div>
              <div class="col-9">{{ tabDetails?.seriestype }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Modality</label></div>
              <div class="col-9">{{ tabDetails?.modality }}</div>
            </li>
            <li class="row">
              <div class="col-3"><label>Series Clean</label></div>
              <div class="col-9">{{ tabDetails?.seriesclean }}</div>
            </li>
          </ng-container>
        </ul>
      </div>

      <div class="col-6">
        <div *ngIf="['patient', 'image'].includes(dataType)">
          <p class="subheading">Tags</p>
          <i
            (click)="editTagsModal.open(data.tags, data, dataType)"
            class="material-icons"
            >mode_edit</i
          >
          <ul>
            <li *ngFor="let key of tagGroups | keys" class="tag-group">
              <label
                (click)="tagGroups[key].open = !tagGroups[key].open"
                [ngClass]="{
                  open: tagGroups[key].open,
                  closed: !tagGroups[key].open
                }"
              >
                <i
                  class="material-icons arrow"
                  [ngClass]="{
                    open: tagGroups[key].open,
                    closed: !tagGroups[key].open
                  }"
                >
                  arrow_drop_down</i
                >
                {{ dataTypeLookup[key] }}</label
              >
              <mat-chip-list *ngIf="tagGroups[key].open">
                <mat-chip
                  *ngFor="let tag of tagGroups[key]"
                  class="search-tag"
                  >{{ tag.name }}</mat-chip
                >
              </mat-chip-list>
            </li>
          </ul>
          <span class="horizontal-span"></span>
        </div>
        <p class="subheading">Notes</p>
        <i
          class="material-icons"
          (click)="editNotesModal.open(dataType, data[dataType + 'Id'])"
          >mode_edit</i
        >
        <div class="notes">
          {{ data?.notes?.body }}
        </div>
      </div>
    </div>

    <lowy-edit-tag #editTagsModal (updated)="updated.emit()"></lowy-edit-tag>
    <lowy-edit-notes
      #editNotesModal
      (updated)="updated.emit()"
    ></lowy-edit-notes>
  `,
  styleUrls: ["../data-details.component.scss"],
  selector: "lowy-details-tab",
  providers: [PatientService],
})
export class DataDetailsTabComponent {
  @Input("data") data: any;
  @Input("tabDetails") tabDetails: any;
  @Input("dataType") dataType: string;

  @Input("tagGroups") tagGroups: {
    [key: string]: Tag;
  };

  @ViewChild("editTagsModal") editTagsModal: EditTagsComponent;
  @ViewChild("editNotesModal") editNotesModal: EditNotesComponent;
  @Output() public updated = new EventEmitter<any>();

  public moment = moment;

  dataTypeLookup: {
    [key: number]: string;
  } = {
    1: "Patient",
    2: "Image",
  };

  constructor(private router: Router, private patientService: PatientService) {}

  public async gotoPatient(patientId) {
    this.router.navigate(["/data", "patient", patientId]);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/data/tabs/details-tab.component.ts